import { api } from '@/main'

const defaultState = {
  residences: [],
  selectedResidence: null,
  selectedResidenceOffers: null,
  residenceOffers: {},
  selectedAccomodation: null,
  selectedAvailability: null
}

export default {
  namespaced: true,
  state: {
    ...defaultState
  },
  mutations: {
    RESET_MODULE: state => {
      Object.keys(state).forEach(key => {
        state[key] = defaultState[key]
      })
    },
    SET_RESIDENCES: (state, residences) =>
      (state.residences = residences),
    SET_SELECTED_RESIDENCE: (state, selectedResidence) =>
      (state.selectedResidence = selectedResidence),
    SET_SELECTED_RESIDENCE_OFFERS: (state, offers) =>
      (state.selectedResidenceOffers = offers),
    SET_RESIDENCE_OFFERS: (state, params) => 
      (state.residenceOffers = {...(state.residenceOffers || {}), [params.id]: params.offers}),
    SET_SELECTED_ACCOMODATION: (state, accomodation) =>
      (state.selectedAccomodation = accomodation),
    SET_SELECTED_AVAILABILITY: (state, availability) =>
      (state.selectedAvailability = availability)
  },
  actions: {
    resetModule(store) {
      store.commit('RESET_MODULE')
    },
    async setResidences(store) {
      const r = await api.residences.getResidences()

      store.commit('SET_RESIDENCES', r)
    },
    async setSelectedResidence(store, id) {
      const r = await api.residences.getResidence({ id })

      store.commit('SET_SELECTED_RESIDENCE', r)
    },
    async getSelectedResidenceOffers(store, data) {
      const r = await api.residences.getResidenceOffers(data)

      store.commit('SET_SELECTED_RESIDENCE_OFFERS', r)
    },
    async getResidenceOffers(store, data) {
      const r = await api.residences.getResidenceOffers(data)

      store.commit('SET_RESIDENCE_OFFERS', {id: data.id, offers: r})
    },
    setSelectedAccomodation(store, accomodation) {
      store.commit('SET_SELECTED_ACCOMODATION', accomodation)
    },
    setSelectedAvailability(store, availability) {
      store.commit('SET_SELECTED_AVAILABILITY', availability)
    }
  }
}
